/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationModel } from '../../models/organization-model';

export interface ConsumerFhirIdGet$Params {
  fhirId: string;
}

export function consumerFhirIdGet(http: HttpClient, rootUrl: string, params: ConsumerFhirIdGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<OrganizationModel>> {
  const rb = new RequestBuilder(rootUrl, consumerFhirIdGet.PATH, 'get');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<OrganizationModel>;
    })
  );
}

consumerFhirIdGet.PATH = '/Consumer/{fhirId}';
